import CRUDService from "./base/CRUDService";

export default class TemplatesDashboardService extends CRUDService {

  getBaseURL() {
    return "ton/v1/dashboard-templates/";
  }

}



// WEBPACK FOOTER //
// ./src/services/TemplatesDashboardService.js